import { makeAutoObservable } from 'mobx';

import { calcTariffTotalPrice } from '../../../buy-ticket/calc-price/calc-tariff-price';
import { TTariffType } from '../../../buy-ticket/types';
import { EOrderStatus, TOrder, TOrderTicket } from '../../../orders/core/order';
import { TTariffOrder } from '../../../tariffs/types';
import { TTrip } from '../../../trips/trip';
import { TTicketUser } from '../../core/tickets';

export class OrdersDataStore {
  _orders: TOrder[] = [];
  _tariffTypes: TTariffType[] = [];
  _tariffs: TTariffOrder[] = [];
  _trips: TTrip[] = [];

  get orders(): TOrder[] {
    return this._orders;
  }

  get tickets(): TTicketUser[] {
    const tickets: TTicketUser[] = [];

    for (const order of this._orders) {
      const isSuccessPay = order.status === EOrderStatus.success;

      if (isSuccessPay) {
        for (const ticket of order.tickets) {
          const isMainTicket = ticket.mainTicketId == undefined;

          if (isMainTicket) tickets.push({ ...ticket, qr: order.ticketQr });
        }
      }
    }

    return tickets;
  }

  constructor() {
    makeAutoObservable(this);
  }

  public getOrderById(id: TOrder['id']): TOrder | undefined {
    return this._orders.find((order) => order.id === id);
  }
  public getMainTicketByOrderId(id: TOrder['id']): TOrderTicket | undefined {
    return this.tickets.find((ticket) => ticket.orderId === id);
  }
  public getMainTicketsByOrderId(id: TOrder['id']): TOrderTicket | undefined {
    return this.tickets.find((ticket) => ticket.orderId === id);
  }
  public getPassengersByOrderId(
    id: TOrder['id']
  ): { wagonNum?: number; seatNum?: number }[] {
    const order = this._orders.find((order) => order.id === id);
    if (!order) return [];

    const mainTariffId = order?.tickets.find(
      (ticket) => ticket.mainTicketId === null
    )?.tariffId;

    if (!mainTariffId) return [];

    const seats = order?.tickets
      .filter((ticket) => ticket.tariffId === mainTariffId)
      .map((ticket) => ({
        wagonNum: ticket.wagonNum,
        seatNum: ticket.seatNum,
      }));

    return seats;
  }

  public getTariffsByOrderId(id: TOrder['id']): {
    sum: number;
    items: {
      id: number;
      titles: { nameHy: string; nameEn: string; nameRu: string };
      summ: number;
    }[];
  } | null {
    const order = this._orders.find((order) => order.id === id);
    if (!order) return null;

    const tariffs = order?.tickets
      .map((ticket) => {
        const { tariffType, discountRules, price } =
          this.getTariffTypeByTariffId(ticket.tariffId);

        const titles = tariffType || {
          nameEn: `Tariff ${ticket.tariffId}`,
          nameHy: `Սակագին ${ticket.tariffId}`,
          nameRu: `Тариф ${ticket.tariffId}`,
        };

        const obj = {
          id: ticket.tariffId,
          titles: titles,
          summ: calcTariffTotalPrice({
            orderDate: order.date,
            tripStartTime: order.date,
            tariff: { price, discountRules },
          }).value,
        };

        return obj;
      })
      .sort((a, b) => a.id - b.id);

    const tariffSum = tariffs.reduce((acc, item) => acc + item.summ, 0);

    const result = {
      sum: tariffSum,
      items: tariffs,
    };

    return result;
  }

  public updateOrder(order: TOrder) {
    const index = this._orders.findIndex((item) => item.id === order.id);
    this._orders[index] = order;
  }

  public updateOrderFeedback(feedback: TOrder['feedback']) {
    if (!feedback) return;

    const index = this._orders.findIndex(
      (item) => item.id === feedback.orderId
    );

    this._orders[index].feedback = feedback;
  }

  public setData(data: {
    orders: TOrder[];
    tariffTypes: TTariffType[];
    trips: TTrip[];
    tariffs: TTariffOrder[];
  }) {
    this._orders = this.sortOrders(data.orders);
    this._tariffTypes = data.tariffTypes;
    this._trips = data.trips;
    this._tariffs = data.tariffs;
  }

  private sortOrders(orders: TOrder[]) {
    return [...orders].sort((a, b) => b.id - a.id);
  }

  public getTariffTypeByTariffId(tariffId: number) {
    const tariff = this._tariffs.find((tariff) => tariff.id === tariffId);
    console.log({ tariff });
    const result = {
      tariffType: tariff?.tariffType,
      discountRules: tariff?.discountRules || [],
      price: tariff?.price || 0,
    };

    return result;
  }

  public getTripById(tripId: number) {
    const trip = this._trips.find((trip) => trip.id === tripId);

    return trip;
  }
}
